import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import { request, RequestError, RequestErrorType } from '@tencent/vft-common/request';
import { setUrlParam } from '@tencent/vft-common/util';

function formatPwd(pwd) {
  return _objectSpread(_objectSpread({}, pwd), {}, {
    text: Array.isArray(pwd.text) ? pwd.text : [pwd.text]
  });
}

export function getPwd(_ref) {
  var pageId = _ref.pageId,
      jumpUrl = _ref.jumpUrl,
      channel = _ref.channel;
  // channel: weixin | wxmoments
  var jumpurl = setUrlParam('ptag', 'passwordshare', jumpUrl);
  return request('https://vip.video.qq.com/fcgi-bin/comm_cgi?name=spp_magic_activity_kouling&cmd=1&otype=xjson', {
    pageid: pageId,
    jumpurl: jumpurl
  }, {
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    },
    timeout: 4000
  }).then(function (res) {
    if (res.ret !== 0) {
      throw new RequestError(res.ret, res.msg, res, RequestErrorType.SYSTEM_ERR);
    }

    var result = {
      weixin: [],
      wxmoments: []
    };

    try {
      if (res.cmdTextList) {
        result.weixin = JSON.parse(res.cmdTextList);
      }

      if (res.friendTextList) {
        result.wxmoments = JSON.parse(res.friendTextList);
      }
    } catch (e) {
      throw new RequestError(-100, '数据格式错误', res, RequestErrorType.SYSTEM_ERR);
    }

    result.weixin.map(formatPwd);
    result.wxmoments.map(formatPwd);

    if (channel) {
      if (!result.hasOwnProperty(channel)) {
        throw new RequestError(-200, '该渠道不存在', null, RequestErrorType.LOGIC_ERR);
      }

      return result[channel];
    }

    return result;
  }, function () {
    throw new RequestError(-500, '请求失败', null, RequestErrorType.NETWORK_ERR);
  });
}